export default {
  order_amount: '订单金额',
  payment_method: '付款方式',
  project: '运营项目',
  project_leader: '项目负责人',
  providers: '服务商',
  use_car_ask: '用车要求',
};
